import React from 'react';
import PropTypes from 'prop-types';
import {titleize} from "../../utils/strings";

import { ensureKeyed } from 'utils';

/**
 * Renders validation errors.
 */
class ValidationErrors extends React.Component {
  static propTypes = {
    /** Errors object of the format field -> array of error message */
    errors: PropTypes.object,

    /** Field name lookup */
    fieldNames: PropTypes.object,

    /** Function that formats error messages with signature (field, error) => message */
    format: PropTypes.func
  };

  static defaultProps = {
    fieldNames: {},
    format: (name, message) => `${name} ${message}`
  };

  render() {
    const {errors = {}} = this.props;

    if (!Object.keys(errors).length) {
      return null;
    } else {
      return <div>
        <div className="alert alert-danger">
          <p>There were problems with the following fields:</p>
          {this.errorsList(errors)}
        </div>
      </div>;
    }
  }

  errorsList(errors) {
    const {format} = this.props;
    return <ul>
      {Object.keys(errors).map((key, _) =>
        errors[key].map(error =>
          <li>{format(this.resolveField(key), error)}</li>).map(ensureKeyed()))}
    </ul>;
  }

  resolveField(field) {
    const {fieldNames} = this.props;
    return fieldNames.hasOwnProperty(field) ? fieldNames[field] : titleize(field);
  }
}

export default ValidationErrors;

